
const UrlBase = "https://api.mirshafiei.ir/";
export default UrlBase;
